import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    installed: [],
    loaderConnect: false
  }),
  methods: {
    createProvider (data, validator = 'provider') {
      /**
       * Create a payment provider connection
       * @param {Object} data - Provider data structured as: { gateway: '', commerce_code: '', extra_data: { secret: '' } }
       * @param {String} validator - Validator name
       * @returns Promise
       */
      this.$v[validator].$touch()
      if (this.$v[validator].$invalid) {
        return false
      }

      this.loaderConnect = true

      this.$store.dispatch('payments/CREATE', {
        resource: 'providers',
        payload: data
      })
      .then(() => {
        this.$dialog.message.info(`${data.gateway} se ha conectado con éxito.`)
        this.$v[validator].$reset()

        // add to installed list
        this.installed.push(data.gateway)
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.loaderConnect = false
      })
    },
    destroyProvider (gateway) {
      /**
       * Destroy a payment provider connection
       * @param {String} gateway - Provider gateway name
       * @returns Promise
       */
      this.$dialog.warning({
        title: 'Desconectar cuenta',
        text: `
          <span class="d-block my-4">¿Estás seguro de desconectar este proveedor de pagos?</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('payments/DESTROY', {
                resource: 'providers',
                id: gateway
              })
              .then(() => {
                this.$dialog.message.info(`${gateway} se ha desconectado con éxito.`)

                // remove from installed list
                this.installed = this.installed.filter((item) => item !== gateway)
              })
              .catch((error) => {
                this.$dialog.message.warning(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    retrieveProvider (gateway) {
      /**
       * Retrieve a payment provider connection
       * @param {String} gateway - Provider gateway name
       * @returns Promise
       */
      this.$store.dispatch('payments/RETRIEVE', {
        resource: 'providers',
        id: gateway
      })
      .then(() => {
        this.installed.push(gateway)
      })
    }
  }
}